import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { GridUtils } from "../../utils/gridUtils";
import {
  setSimpleFilterQuery,
  setAdvancedFilterQuery,
} from "../../utils/tableUtils";
import { AppSessionService } from "../app-session/app-session.service";

const EMPTY_STRING = "";
@Injectable({
  providedIn: "root",
})
export class TankGaugeService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}

  getTankGauges(code: string, pageReq?: PaginationRequest): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let url = `${this.appSession.baseUrl}/api/v1/sites/${code}/devices/tankLevelGauges`;

    if (pageReq) {
      const { realSize, offset, limit } = pageReq;
      url = url + `?real_size=${realSize}&offset=${offset}&limit=${limit}`;
    }

    return this.http.get(url, { headers });
  }

  getTankGaugeTypes(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Content-type",
      "application/x-www-form-urlencoded; "
    );

    if (pageReq && pageReq.query && (pageReq.query as string).length > 0) {
      headers = headers.set("query", pageReq.query);
    }

    const url = `${
      this.appSession.baseUrl + "/api/v1/devices/tankLevelGaugeTypes"
    }`;

    if (!pageReq) {
      pageReq = {
        offset: 0,
        limit: 100,
        realSize: false,
      };
    }

    return this.http.get(url, { headers });
  }

  getTankGauge(code): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${
      this.appSession.baseUrl + "/api/v1/devices/tankLevelGauges"
    }/${code}`;
    return this.http.get(url, { headers });
  }

  createTankGauge(tankGauge): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(tankGauge);
    const url = `${
      this.appSession.baseUrl + "/api/v1/devices/tankLevelGauges"
    }`;
    return this.http.post(url, data, { headers });
  }

  updateTankGauge(tankGauge): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(tankGauge);
    const url = `${
      this.appSession.baseUrl + "/api/v1/devices/tankLevelGauges"
    }/${tankGauge?.code}`;
    return this.http.put(url, data, { headers });
  }

  private buildDataUrl(
    pagingArgs: any,
    filteringArgs: any,
    sortingArgs: any,
    header: HttpHeaders,
    path: string
  ): string {
    let baseQueryString = `${
      this.appSession.baseUrl + "/api/v1/devices/tankLevelGauges"
    }${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }
}
